import React, { useEffect, useRef, useState } from "react";
import {
  getCurrentDate,
  minutesToHHMM,
  timeToMinutes,
} from "../../../../Utilitie";
import { BsFillCaretDownFill, BsFillCaretUpFill } from "react-icons/bs";
import DownloadExcel from "../../../../Extra/DownloadExcel";

const tableHead = [
  "Trains",
  "Avg Time",
  "Total Time",
  "Trains",
  "Avg Time",
  "Total Time",
  "Trains",
  "Avg Time",
  "Total Time",
  "Trains",
  "Avg Time",
  "Total Time",
];

const PDDMonthYearTable = ({
  data,
  setSelectedDate,
  setStartDate,
  selectedDate,
  startDate,
  setFetchState,
  fetchState,
}) => {
  const [date, setDate] = useState(getCurrentDate());
  const tableRef = useRef();
  useEffect(() => {
    setSelectedDate(date);
  }, [date]);

  // Month Section
  const monthSection = data?.find((item) => item.filtered_by === "month");
  const mcurrent = monthSection?.current?.data || [];
  const mprevious = monthSection?.previous?.data || [];

  const previousmonthMap = {};
  mprevious.forEach((station) => {
    previousmonthMap[station.station_id] = station;
  });

  // Year Section
  const yearSection = data?.find(
    (item) => item.filtered_by === "financial_year",
  );
  const ycurrent = yearSection?.current?.data || [];
  const yprevious = yearSection?.previous?.data || [];

  const previousYearMap = {};
  yprevious.forEach((station) => {
    previousYearMap[station.station_id] = station;
  });
  // Calculate totals for each column
  const calculateTotals = (dataArray) => ({
    total_trains_count: dataArray.reduce(
      (sum, item) => sum + (Number(item.total_trains_count) || 0),
      0,
    ),
    avg_avg_time: dataArray
      .reduce((sum, item) => sum + (timeToMinutes(item.avg_avg_time) || 0), 0)
      .toFixed(2),
    total_total_time: dataArray.reduce(
      (sum, item) => sum + (Number(item.total_total_time) || 0),
      0,
    ),
  });

  const mcurrentTotals = calculateTotals(mcurrent);
  const mpreviousTotals = calculateTotals(mprevious);
  const ycurrentTotals = calculateTotals(ycurrent);
  const ypreviousTotals = calculateTotals(yprevious);

  const totalYCVeriation =
    ycurrentTotals.total_total_time !== 0
      ? (
          ((ycurrentTotals.total_total_time -
            ypreviousTotals.total_total_time) *
            100) /
          ypreviousTotals.total_total_time
        ).toFixed(2)
      : "-";

  const totalMCVeriation =
    mcurrentTotals.total_total_time !== 0
      ? (
          ((mcurrentTotals.total_total_time -
            mpreviousTotals.total_total_time) *
            100) /
          mpreviousTotals.total_total_time
        ).toFixed(2)
      : "-";
  return (
    <div className="newUiBody">
      <div className="row ms-1 me-1">
        <div className="p-1 d-flex justify-content-between align-items-center bg-dark text-white">
          <h6 className="">PDD Data Till ({date})</h6>
          <div className="d-flex">
            <input
              className=""
              type="date"
              max={selectedDate}
              value={startDate}
              onChange={(e) => {
                setStartDate(e.target.value);
              }}
            />{" "}
            <input
              className=""
              type="date"
              min={startDate}
              max={getCurrentDate()}
              value={date}
              onChange={(e) => {
                setDate(e.target.value);
              }}
            />
            <button
              className="btn btn-sm btn-outline-light"
              onClick={() => setFetchState(!fetchState)}
            >
              fetch
            </button>
          </div>
        </div>
      </div>
      <div>
        <div
          className="table-responsive text-wrap mt-1"
          style={{ fontSize: "12px", fontWeight: "bold" }}
        >
          <table
            className="table newUiTable table-hover table-bordered table-striped"
            ref={tableRef}
          >
            <thead className="thead-dark">
              <tr className="table-dark">
                <th
                  className="text-wrap"
                  rowSpan={3}
                  style={{
                    maxWidth: "50px",
                    textAlign: "center",
                    verticalAlign: "middle",
                  }}
                >
                  Station Name
                </th>
                <th colSpan={7} className="text-center">
                  Monthly
                  {monthSection?.start_date}
                </th>
                <th colSpan={7} className="text-center">
                  Yearly
                </th>
              </tr>
              <tr
                className="table-dark"
                style={{
                  maxWidth: "50px",
                  textAlign: "center",
                  verticalAlign: "middle",
                }}
              >
                <td colSpan={3}>
                  {monthSection?.previous?.start_date} /{" "}
                  {monthSection?.previous?.end_date}
                </td>
                <td colSpan={3}>
                  {monthSection?.current?.start_date} /{" "}
                  {monthSection?.current?.end_date}
                </td>
                <td rowSpan={2} className="text-wrap m-0 p-0">
                  Monthly Variation
                </td>
                <td colSpan={3}>
                  {yearSection?.previous?.start_date} /{" "}
                  {yearSection?.previous?.end_date}
                </td>
                <td colSpan={3}>
                  {yearSection?.current?.start_date} /{" "}
                  {yearSection?.current?.end_date}
                </td>
                <td rowSpan={2} className="text-wrap m-0 p-0">
                  Yearly Variation
                </td>
              </tr>
              <tr className="table-dark">
                {tableHead.map((name, key) => (
                  <th
                    className="text-wrap"
                    key={key}
                    style={{
                      maxWidth: "50px",
                      textAlign: "center",
                      verticalAlign: "middle",
                    }}
                  >
                    {name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data &&
                mcurrent.map((station) => {
                  const monthly =
                    mcurrent.find((s) => s.station_id === station.station_id) ||
                    {};
                  const prevMonth = previousmonthMap[station.station_id] || {};
                  const yearly =
                    ycurrent.find((s) => s.station_id === station.station_id) ||
                    {};
                  const prevYear = previousYearMap[station.station_id] || {};
                  const variation =
                    monthly.total_total_time !== 0
                      ? (
                          ((monthly.total_total_time -
                            prevMonth.total_total_time) *
                            100) /
                          prevMonth.total_total_time
                        ).toFixed(2)
                      : "-";
                  const yearlyvariation =
                    yearly.total_total_time !== 0
                      ? (
                          ((yearly.total_total_time -
                            prevYear.total_total_time) *
                            100) /
                          prevYear.total_total_time
                        ).toFixed(2)
                      : "-";

                  return (
                    <tr key={station.station_id}>
                      <td className="text-wrap">
                        {station.station_code || "----"}
                      </td>
                      {/* Monthly Data */}
                      <td>{prevMonth.total_trains_count || "-"}</td>
                      <td>{prevMonth.avg_avg_time || "-"}</td>
                      <td>
                        {minutesToHHMM(prevMonth.total_total_time) || "-"}
                      </td>
                      <td>{monthly.total_trains_count || "-"}</td>
                      <td>{monthly.avg_avg_time || "-"}</td>
                      <td>{minutesToHHMM(monthly.total_total_time) || "-"}</td>
                      <td>
                        <div
                          className="m-1 text-center p-1"
                          style={{
                            borderRadius: "5px",
                            background:
                              variation > 0
                                ? "rgba(233, 75, 75, 0.9)"
                                : "rgba(88, 223, 61, 0.78)",
                            color: variation > 0 ? "white" : "black",
                          }}
                        >
                          {variation > 0 ? (
                            <BsFillCaretUpFill />
                          ) : (
                            <BsFillCaretDownFill />
                          )}
                          {variation}
                        </div>
                      </td>
                      {/* Yearly Data */}
                      <td>{prevYear.total_trains_count || "-"}</td>
                      <td>{prevYear.avg_avg_time || "-"}</td>
                      <td>{minutesToHHMM(prevYear.total_total_time) || "-"}</td>
                      <td>{yearly.total_trains_count || "-"}</td>
                      <td>{yearly.avg_avg_time || "-"}</td>
                      <td>{minutesToHHMM(yearly.total_total_time) || "-"}</td>
                      <td>
                        <div
                          className="m-1 text-center p-1"
                          style={{
                            borderRadius: "5px",
                            color: yearlyvariation > 0 ? "white" : "black",
                            background:
                              yearlyvariation > 0
                                ? "rgba(233, 75, 75, 0.9)"
                                : "rgba(88, 223, 61, 0.78)",
                          }}
                        >
                          {yearlyvariation > 0 ? (
                            <BsFillCaretUpFill />
                          ) : (
                            <BsFillCaretDownFill />
                          )}
                          {yearlyvariation}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              <tr className="table-dark">
                <td>Total</td>
                <td>{mpreviousTotals.total_trains_count || "-"}</td>
                <td>
                  {minutesToHHMM(
                    (mpreviousTotals.avg_avg_time / mprevious.length).toFixed(
                      0,
                    ),
                    true,
                  ) || "-"}
                </td>
                <td>
                  {minutesToHHMM(mpreviousTotals.total_total_time) || "-"}
                </td>
                <td>{mcurrentTotals.total_trains_count || "-"}</td>
                <td>
                  {minutesToHHMM(
                    (mcurrentTotals.avg_avg_time / mcurrent.length).toFixed(0),
                    true,
                  ) || "-"}
                </td>

                <td>{minutesToHHMM(mcurrentTotals.total_total_time) || "-"}</td>
                <td>
                  <div
                    className="m-1 text-center p-1"
                    style={{
                      borderRadius: "5px",
                      color: totalYCVeriation > 0 ? "white" : "black",
                      background:
                        totalMCVeriation > 0
                          ? "rgba(233, 75, 75, 0.9)"
                          : "rgba(88, 223, 61, 0.78)",
                    }}
                  >
                    {totalMCVeriation > 0 ? (
                      <BsFillCaretUpFill />
                    ) : (
                      <BsFillCaretDownFill />
                    )}
                    {totalMCVeriation}
                  </div>
                </td>
                <td>{ypreviousTotals.total_trains_count || "-"}</td>
                <td>
                  {minutesToHHMM(
                    (ypreviousTotals.avg_avg_time / yprevious.length).toFixed(
                      0,
                    ),
                    true,
                  ) || "-"}
                </td>
                <td>
                  {minutesToHHMM(ypreviousTotals.total_total_time) || "-"}
                </td>
                <td>{ycurrentTotals.total_trains_count || "-"}</td>
                <td>
                  {minutesToHHMM(
                    (ycurrentTotals.avg_avg_time / ycurrent.length).toFixed(0),
                    true,
                  ) || "-"}
                </td>
                <td>{minutesToHHMM(ycurrentTotals.total_total_time) || "-"}</td>
                <td>
                  <div
                    className="m-1 text-center p-1"
                    style={{
                      borderRadius: "5px",
                      color: totalYCVeriation > 0 ? "white" : "black",
                      background:
                        totalYCVeriation > 0
                          ? "rgba(233, 75, 75, 0.9)"
                          : "rgba(88, 223, 61, 0.78)",
                    }}
                  >
                    {totalYCVeriation > 0 ? (
                      <BsFillCaretUpFill />
                    ) : (
                      <BsFillCaretDownFill />
                    )}
                    {totalYCVeriation}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          {!data ? (
            <b style={{ color: "red", fontSize: "14px" }}>Data not found!</b>
          ) : null}
          <DownloadExcel
            tableRef={tableRef}
            fileName={`PDD commutative data (month-year)  - ${getCurrentDate()}`}
          />
        </div>
      </div>
    </div>
  );
};

export default PDDMonthYearTable;
